import React from 'react'
import { Actor, Spell } from '../redux/models'
import { ActorRow } from './ActorRow'
import { SpellRow } from './SpellRow'

type Props = {
    index: number
    actor: Actor
    spells: Spell[]

    onEditActor: () => void
    onChangeOrdinal: (dir: "up" | "down") => void
    onSpellRowClicked: (spell: Spell) => void
}

export const ActorBock = (props: Props): JSX.Element | null => {

    return (
        <div>
            <ActorRow
                index={props.index}
                actor={props.actor}
                onEditActor={props.onEditActor}
                onChangeOrdinal={props.onChangeOrdinal}
            />

            {props.spells.map(spell => {
                return (
                    <SpellRow
                        key={spell.id}
                        spell={spell}
                        onClick={props.onSpellRowClicked}
                    />
                )
            })}
        </div>
    )
}
